(function () {
  'use strict';

  const LAYERS = ['top', 'middle', 'base'];
  const MAX_PER_LAYER = 3;
  const MAX_TOTAL = 9;
  const TYPE_OTHER = 'Something else';

  class ScentMemory extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.maxPerLayer = Number(this.dataset.maxPerLayer || MAX_PER_LAYER);
      this.maxTotal = Number(this.dataset.maxTotal || MAX_TOTAL);
      this.layers = { top: [], middle: [], base: [] };
      this.activeLayer = 'top';

      this.$ = (sel) => this.querySelector(sel);
      this.$$ = (sel) => Array.from(this.querySelectorAll(sel));

      this.form = this.$('[data-sm-form]');
      this.variantInput = this.$('[name="id"]');
      this.topInput = this.$('[data-sm-top-input]');
      this.middleInput = this.$('[data-sm-middle-input]');
      this.baseInput = this.$('[data-sm-base-input]');
      this.memoryTypeInput = this.$('[data-sm-memory-type-input]');
      this.submitBtn = this.$('[data-sm-submit]');
      this.statusEl = this.$('[data-sm-status]');
      this.errorEl = this.$('[data-sm-error]');
      this.memoryInput = this.$('[data-sm-memory-name]');
      this.memoryAbout = this.$('[data-sm-memory-about]');
      this.memoryNameLabel = this.$('[data-sm-memory-name-label]');
      this.detailsEl = this.$('[data-sm-details]');
      this.counterEl = this.$('[data-sm-counter]');
      this.labelMemory = this.$('[data-sm-label-memory]');
      this.labelType = this.$('[data-sm-label-type]');
      this.labelNotes = this.$('[data-sm-label-notes]');
      this.liquidEl = this.$('[data-sm-liquid]');
      this.blendCount = this.$('[data-sm-blend-count]');
      this.pickerTitle = this.$('[data-sm-picker-title]');
      this.pickerCount = this.$('[data-sm-picker-count]');
      this.allNotesWrap = this.$('[data-sm-all-notes]');
      this.showAllBtn = this.$('[data-sm-show-all]');

      this.bindEvents();
      this.setActiveLayer(this.activeLayer);
      this.applyMemoryType(this.getMemoryType());
      this.syncUI();
    }

    bindEvents() {
      this.addEventListener('click', (evt) => {
        const layerBtn = evt.target.closest('[data-sm-layer-select]');
        if (layerBtn) {
          const row = layerBtn.closest('[data-sm-layer]');
          if (row) this.setActiveLayer(row.dataset.smLayer);
          return;
        }

        const slot = evt.target.closest('[data-sm-slot]');
        if (slot && !evt.target.closest('[data-sm-slot-remove]')) {
          const row = slot.closest('[data-sm-layer]');
          if (row) this.setActiveLayer(row.dataset.smLayer);
          return;
        }

        const removeBtn = evt.target.closest('[data-sm-slot-remove]');
        if (removeBtn) {
          evt.preventDefault();
          evt.stopPropagation();
          this.removeNoteAt(removeBtn.dataset.layer, Number(removeBtn.dataset.index));
          return;
        }

        const noteBtn = evt.target.closest('[data-sm-note]');
        if (noteBtn) {
          evt.preventDefault();
          evt.stopPropagation();
          if (noteBtn.disabled) return;
          this.addNote(noteBtn.dataset.name, noteBtn.dataset.color);
        }
      });

      if (this.showAllBtn) {
        this.showAllBtn.addEventListener('click', () => {
          const open = this.allNotesWrap && !this.allNotesWrap.hidden;
          if (this.allNotesWrap) this.allNotesWrap.hidden = open;
          this.showAllBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
          this.showAllBtn.classList.toggle('is-open', !open);
          const label = open
            ? this.dataset.showAllLabel || this.showAllBtn.textContent
            : this.dataset.hideAllLabel || this.showAllBtn.textContent;
          const textEl = this.showAllBtn.querySelector('[data-sm-show-all-label]');
          if (textEl) textEl.textContent = label;
        });
      }

      this.$$('[data-sm-memory-type]').forEach((input) => {
        input.addEventListener('change', () => {
          this.applyMemoryType(input.value);
          this.syncUI();
        });
      });

      this.$$('[data-sm-variant]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.variantInput.value = input.value;
          this.syncUI();
        });
      });

      if (this.memoryInput) {
        this.memoryInput.addEventListener('input', () => {
          this.updateCounter();
          this.syncUI();
        });
      }

      if (this.form) {
        this.form.addEventListener('submit', (evt) => this.onSubmit(evt));
      }
    }

    applyMemoryType(value) {
      const isPlaceOrPerson = value === 'Place' || value === 'Person';
      const isOther = value === TYPE_OTHER;

      if (this.memoryTypeInput) {
        if (value) {
          this.memoryTypeInput.disabled = false;
          this.memoryTypeInput.value = value;
        } else {
          this.memoryTypeInput.value = '';
          this.memoryTypeInput.disabled = true;
        }
      }

      if (this.detailsEl) {
        this.detailsEl.hidden = !isPlaceOrPerson;
      }

      if (this.memoryInput) {
        this.memoryInput.disabled = !isPlaceOrPerson;
        if (!isPlaceOrPerson) this.memoryInput.value = '';
        this.memoryInput.placeholder =
          value === 'Person'
            ? this.dataset.placeholderPerson || ''
            : this.dataset.placeholderPlace || '';
      }

      if (this.memoryAbout) {
        this.memoryAbout.disabled = !isPlaceOrPerson;
        if (!isPlaceOrPerson) this.memoryAbout.value = '';
      }

      if (this.memoryNameLabel) {
        this.memoryNameLabel.textContent =
          value === 'Person'
            ? this.dataset.memoryLabelPerson || this.memoryNameLabel.textContent
            : this.dataset.memoryLabelPlace || this.memoryNameLabel.textContent;
      }

      if (this.labelType) {
        if (isOther) {
          this.labelType.textContent = this.dataset.labelTypeOther || value;
        } else if (value === 'Person') {
          this.labelType.textContent = this.dataset.labelTypePerson || value;
        } else if (value === 'Place') {
          this.labelType.textContent = this.dataset.labelTypePlace || value;
        } else {
          this.labelType.textContent = this.dataset.labelTypeDefault || '';
        }
      }

      this.updateCounter();
    }

    updateCounter() {
      if (!this.counterEl || !this.memoryInput) return;
      const max = Number(this.memoryInput.getAttribute('maxlength') || 40);
      this.counterEl.textContent = `${this.memoryInput.value.length}/${max}`;
    }

    setActiveLayer(layer) {
      if (!LAYERS.includes(layer)) return;
      this.activeLayer = layer;
      this.$$('[data-sm-layer]').forEach((row) => {
        const active = row.dataset.smLayer === layer;
        row.classList.toggle('is-active', active);
        const selectBtn = row.querySelector('[data-sm-layer-select]');
        if (selectBtn) selectBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (this.pickerTitle) {
        const titles = {
          top: this.dataset.addingTop || 'Top note',
          middle: this.dataset.addingMiddle || 'Middle note',
          base: this.dataset.addingBase || 'Base note'
        };
        this.pickerTitle.textContent = titles[layer];
      }
      this.syncUI();
    }

    addNote(name, color) {
      if (!name || !LAYERS.includes(this.activeLayer)) return;
      const list = this.layers[this.activeLayer];
      if (list.length >= this.maxPerLayer) return;
      if (this.totalNotes() >= this.maxTotal) return;
      list.push({ name, color: color || '#C9A27E' });
      this.syncUI();
    }

    removeNoteAt(layer, index) {
      if (!this.layers[layer] || !this.layers[layer][index]) return;
      this.layers[layer].splice(index, 1);
      this.syncUI();
    }

    totalNotes() {
      return LAYERS.reduce((sum, key) => sum + this.layers[key].length, 0);
    }

    renderLayerSlots() {
      LAYERS.forEach((layer) => {
        const row = this.$(`[data-sm-layer="${layer}"]`);
        if (!row) return;
        const notes = this.layers[layer];
        const countEl = row.querySelector('[data-sm-layer-count]');
        if (countEl) {
          countEl.textContent = `${notes.length}/${this.maxPerLayer}`;
        }
        row.querySelectorAll('[data-sm-slot]').forEach((slot, i) => {
          const note = notes[i];
          const nameEl = slot.querySelector('[data-sm-slot-name]');
          const dotEl = slot.querySelector('[data-sm-slot-dot]');
          const removeBtn = slot.querySelector('[data-sm-slot-remove]');
          const emptyLabel = slot.dataset.emptyLabel || (i === 0 ? 'Add a note' : 'Optional');
          slot.classList.toggle('is-filled', !!note);
          if (note) {
            if (nameEl) nameEl.textContent = note.name;
            if (dotEl) {
              dotEl.style.background = note.color;
              dotEl.textContent = '';
            }
            if (removeBtn) {
              removeBtn.hidden = false;
              removeBtn.dataset.layer = layer;
              removeBtn.dataset.index = String(i);
            }
          } else {
            if (nameEl) nameEl.textContent = emptyLabel;
            if (dotEl) {
              dotEl.style.background = '';
              dotEl.textContent = String(i + 1);
            }
            if (removeBtn) removeBtn.hidden = true;
          }
        });
      });
    }

    renderBlend() {
      const total = this.totalNotes();
      if (this.blendCount) {
        this.blendCount.textContent = `${total} of ${this.maxTotal} notes`;
      }
      LAYERS.forEach((layer) => {
        const el = this.$(`[data-sm-blend-${layer}]`);
        if (!el) return;
        const notes = this.layers[layer];
        el.textContent = notes.length
          ? notes.map((n) => n.name).join(', ')
          : this.dataset.blendEmpty || 'Not chosen yet';
        el.classList.toggle('is-empty', notes.length === 0);
      });
    }

    renderBottle() {
      if (this.liquidEl) {
        const ordered = [...this.layers.base, ...this.layers.middle, ...this.layers.top];
        const maxFill =
          getComputedStyle(this).getPropertyValue('--sm-liquid-max').trim() || '80%';
        const maxPct = parseFloat(maxFill) || 80;
        const total = ordered.length;
        this.liquidEl.style.height = total ? `${(total / this.maxTotal) * maxPct}%` : '0%';
        this.liquidEl.innerHTML = ordered
          .map((n) => `<span class="scent-memory__liquid-layer" style="background:${n.color}"></span>`)
          .join('');
      }

      if (this.labelMemory) {
        const value = this.memoryInput && !this.memoryInput.disabled && this.memoryInput.value.trim();
        this.labelMemory.textContent = value || this.dataset.labelMemoryEmpty || '';
      }

      if (this.labelNotes) {
        const parts = [];
        if (this.layers.top.length) parts.push(this.layers.top.map((n) => n.name).join(', '));
        if (this.layers.middle.length) parts.push(this.layers.middle.map((n) => n.name).join(', '));
        if (this.layers.base.length) parts.push(this.layers.base.map((n) => n.name).join(', '));
        this.labelNotes.textContent = parts.join(' · ');
      }
    }

    syncNoteButtons() {
      const activeList = this.layers[this.activeLayer] || [];
      const layerFull = activeList.length >= this.maxPerLayer;
      const totalFull = this.totalNotes() >= this.maxTotal;
      const canAdd = !layerFull && !totalFull;

      if (this.pickerCount) {
        this.pickerCount.textContent = `${activeList.length}/${this.maxPerLayer}`;
      }

      this.$$('[data-sm-note]').forEach((btn) => {
        const count = activeList.filter((n) => n.name === btn.dataset.name).length;
        btn.classList.toggle('is-selected', count > 0);
        btn.setAttribute('aria-pressed', count > 0 ? 'true' : 'false');
        if (count > 1) {
          btn.setAttribute('data-count', String(count));
        } else {
          btn.removeAttribute('data-count');
        }
        // Same note can be added again until the layer (or blend) is full.
        // Remove copies with the slot × buttons.
        btn.disabled = !canAdd;
      });
    }

    syncHiddenInputs() {
      if (this.topInput) this.topInput.value = this.layers.top.map((n) => n.name).join(', ');
      if (this.middleInput) this.middleInput.value = this.layers.middle.map((n) => n.name).join(', ');
      if (this.baseInput) this.baseInput.value = this.layers.base.map((n) => n.name).join(', ');
    }

    syncUI() {
      this.renderLayerSlots();
      this.renderBlend();
      this.renderBottle();
      this.syncNoteButtons();
      this.syncHiddenInputs();
      this.updateCounter();

      const ready = this.isReady();
      LAYERS.forEach((layer) => {
        if (!this[`${layer}Input`]) return;
        const input = this[`${layer}Input`];
        const msg = (this.dataset.errorNotes || 'Please choose at least one [layer] note').replace(
          '[layer]',
          layer
        );
        input.setCustomValidity(this.layers[layer].length >= 1 ? '' : msg);
      });

      if (this.submitBtn) {
        this.submitBtn.disabled = !ready;
        this.submitBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      }
      if (this.statusEl) {
        this.statusEl.classList.toggle('is-ready', ready);
        this.statusEl.textContent = ready
          ? this.dataset.statusReady || ''
          : this.dataset.statusIncomplete || '';
      }

      const sticky = this.$('[data-sm-sticky]');
      const stickySubmit = this.$('[data-sm-sticky-submit]');
      if (sticky) sticky.hidden = false;
      if (stickySubmit) {
        stickySubmit.disabled = !ready;
        stickySubmit.setAttribute('aria-disabled', ready ? 'false' : 'true');
      }
      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    getMemoryType() {
      const checked = this.$('[data-sm-memory-type]:checked');
      return checked ? checked.value : '';
    }

    isReady() {
      return (
        LAYERS.every((layer) => this.layers[layer].length >= 1) &&
        !!(this.variantInput && this.variantInput.value)
      );
    }

    onSubmit(evt) {
      evt.preventDefault();

      if (!this.isReady()) {
        if (this.errorEl) {
          this.errorEl.hidden = false;
          this.errorEl.textContent =
            this.dataset.errorIncomplete ||
            'Please choose at least one note in each layer before adding to basket.';
        }
        return;
      }

      if (!this.form.reportValidity()) return;

      const submitBtn = this.submitBtn;
      if (submitBtn) {
        if (submitBtn.classList.contains('thb-loading')) return;
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('thb-loading');
      }

      this.clearFormError();

      const formData = new FormData(this.form);
      for (const key of [...formData.keys()]) {
        if (!key.startsWith('properties[')) continue;
        const value = formData.get(key);
        if (typeof value === 'string' && !value.trim()) formData.delete(key);
      }
      const sections = this.getSectionsToRender().map((section) => section.section);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      const cartAddUrl =
        (window.theme && theme.routes && theme.routes.cart_add_url) ||
        (window.routes && window.routes.cart_add_url) ||
        '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showFormError(
              response.description || response.message || this.dataset.errorGeneric || ''
            );
            return;
          }
          this.renderCartSections(response);
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', {
              product: response.items ? response.items[0] : response
            });
          }
          const toggle = document.getElementById('cart-drawer-toggle');
          if (toggle && document.getElementById('Cart-Drawer')) {
            toggle.click();
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart-drawer:open');
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.showFormError(this.dataset.errorGeneric || '');
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.classList.remove('thb-loading');
            this.syncUI();
          }
        });
    }

    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.float_count' }
      ];
    }

    renderCartSections(parsedState) {
      if (!parsedState.sections) return;
      this.getSectionsToRender().forEach((section) => {
        const root = document.getElementById(section.id);
        if (!root || !parsedState.sections[section.section]) return;
        const target = root.querySelector(section.selector) || root;
        const html = new DOMParser()
          .parseFromString(parsedState.sections[section.section], 'text/html')
          .querySelector(section.selector);
        if (html) target.innerHTML = html.innerHTML;
        if (section.id === 'Cart-Drawer' && typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
      });
    }

    showFormError(message) {
      const wrap = this.$('[data-sm-form-error]');
      const text = wrap && wrap.querySelector('.product-form__error-message');
      if (!wrap || !text) {
        if (this.errorEl) {
          this.errorEl.hidden = false;
          this.errorEl.textContent = message;
        }
        return;
      }
      wrap.hidden = false;
      text.textContent = message;
    }

    clearFormError() {
      const wrap = this.$('[data-sm-form-error]');
      if (wrap) {
        wrap.hidden = true;
        const text = wrap.querySelector('.product-form__error-message');
        if (text) text.textContent = '';
      }
    }
  }

  if (!customElements.get('scent-memory')) {
    customElements.define('scent-memory', ScentMemory);
  }
})();
